import React, { createContext, useState, useMemo, useCallback } from 'react';
export const SnackBarContext = createContext();

const SnackBarContextProvider = (props) => {
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [infoAlert, setInfoAlert] = useState({});
    
    // Use useCallback for functions to prevent unnecessary re-renders
    const handleCloseSnackBar = useCallback((event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackBar(false);
    }, []);
    
    // Memoized setter functions to avoid creating new functions on every render
    const setSnackBarOpen = useCallback((isOpen) => {
        setOpenSnackBar(isOpen);
    }, []);
    
    const setSnackBarInfo = useCallback((info) => {
        setInfoAlert(info);
    }, []);

    // Memoize the context value
    const value = useMemo(() => ({
        openSnackBar,
        setOpenSnackBar: setSnackBarOpen,
        infoAlert,
        setInfoAlert: setSnackBarInfo,
        handleCloseSnackBar
    }), [openSnackBar, infoAlert, setSnackBarOpen, setSnackBarInfo, handleCloseSnackBar]);

    return (
        <SnackBarContext.Provider value={value}>
            {props.children}
        </SnackBarContext.Provider>
    );
};

export default SnackBarContextProvider;